import { render } from "./SingleSupportMessage.vue?vue&type=template&id=8c9447a2&scoped=true&ts=true"
import script from "./SingleSupportMessage.vue?vue&type=script&lang=ts"
export * from "./SingleSupportMessage.vue?vue&type=script&lang=ts"

import _style_0 from "./SingleSupportMessage.vue?vue&type=style&index=0&id=8c9447a2&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-8c9447a2"]])

export default __exports__